import * as React from "react";
import { useCookieConsentContext, isCookieCategoryEnabled } from "@grandvisionhq/cookie-consent";
import { TealiumService } from "./service.js";
const TealiumContext = React.createContext(null);
TealiumContext.displayName = "TealiumContext";
const TealiumProvider = (props) => {
  const { enableCookieCheck, sdkUrl, children } = props;
  const consentResult = useCookieConsentContext();
  const consentGranted = isCookieCategoryEnabled("analytics", consentResult);
  const shouldTealiumLoad = enableCookieCheck ? consentGranted : true;
  const ref = React.useRef(TealiumService.createInstance(sdkUrl));
  React.useEffect(() => {
    const cleanup = ref.current?.listen();
    return cleanup;
  }, []);
  React.useEffect(() => {
    if (shouldTealiumLoad) {
      const service = ref.current;
      service?.load();
      return () => {
        service?.teardown();
      };
    }
  }, [shouldTealiumLoad]);
  return /* @__PURE__ */ React.createElement(TealiumContext.Provider, { value: null }, children);
};
export {
  TealiumProvider
};
//# sourceMappingURL=provider.js.map
